"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OverviewAggregateConfigModel = /** @class */ (function () {
    function OverviewAggregateConfigModel() {
        /**
         * @property sourceField will contain array-like field that needs to be aggregated.
         * Otherwise, when card is {@link OverviewCardType.GROUP_CARD}, the aggregation will
         * work on set of Entities, grouped by selected field (and source field will not be needed).
         * Allowed values are: ({@link MetaFieldType.MULTI_SELECT and @link MetaFieldType.SUB_ENTITY})
         */
        this.sourceField = null;
        /**
         *
         * @property groupingField in both cases will contain the field, by which entities are grouped.
         * Allowed values are: ({@link MetaFieldType.CLASSIFIER, @link MetaFieldType.MAIN_ENTITY and @link MetaFieldType.WORKFLOW_STATE})
         */
        this.groupingField = null;
        this.aggregateFunction = null;
        this.aggregateField = null;
    }
    return OverviewAggregateConfigModel;
}());
exports.OverviewAggregateConfigModel = OverviewAggregateConfigModel;
//# sourceMappingURL=overview-aggregate-config.model.js.map